<template>
  <div class="bettery-malfunction-bd tb">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <!-- 导出 -->
        <el-form-item v-if="funcView.batteryMalfunction_export" style="float: right" :class="{ 'mr-0': funcView.batteryMalfunction_export }">
          <el-button class="table-set" style="vertical-align: top" @click="exportTable('faultBatteryAbnormalExport', formSearch)">
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <el-form-item style="float: right" :class="{ 'mr-0': !funcView.batteryMalfunction_export }">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input v-model="formSearch.search" :placeholder="$t('asm_batteryMalfunction.ji_shen_hao')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <el-form-item :label="$t('asm_batteryMalfunction.ku_cun_fang')">
          <el-input v-model="formSearch.orgName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('asm_batteryMalfunction.dai_li_gong_si')">
          <el-input v-model="formSearch.agentCoName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('asm_batteryMalfunction.shou_hou_gong_si')">
          <el-input v-model="formSearch.afterServiceName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('asm_batteryMalfunction.geng_xin_shi_jian')">
          <custom-date-picker
            style="width: 100%"
            @change="onPageChange({ page: 1 })"
            v-model="gmtModified"
            type="daterange"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="beforeToday"
          ></custom-date-picker>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table ref="table" index height="100%" tableCode="batteryAbnormalDevice" :data="tableList" @filter="filterChange" @sort="sortChange" @column="setColumn" :slots="['bodyNum', 'contractNo']">
        <template v-slot:bodyNum="scope">
          <div class="cell-link" @click="jump('/devicedetail', { deviceId: scope.row.deviceId, parentPath: $route.path })">{{ scope.row.bodyNum }}</div>
        </template>
        <template v-slot:contractNo="scope">
          <div v-if="scope.row.orderId" class="cell-link" @click="jump('/contractdetail', { contractId: scope.row.orderId, contractClass: scope.row.orderType, parentPath: $route.path })">{{ scope.row.contractNo }}</div>
          <div v-else>{{ scope.row.contractNo }}</div>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  name: 'batteryMalfunction',
  components: {},
  data() {
    return {
      formSearch: {
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,

        orgName: '',
        customerName: '',
        afterServiceName: '',
        agentCoName: '',
        startGmtModified: '',
        endGmtModified: '',
      },

      gmtModified: [],
      tableList: [],
      totalRows: null,

      link: null,
    };
  },
  activated: function () {
    this.getTableList();
  },
  mounted: function () {
    this.resetFormSearch = JSON.stringify(this.formSearch);

    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });
  },
  methods: {
    // 获取表格数据列表
    getTableList: function () {
      this.formSearch.startGmtModified = this.gmtModified ? this.gmtModified[0] : '';
      this.formSearch.endGmtModified = this.gmtModified ? this.gmtModified[1] : '';
      this.$getJSON(apis.faultBatteryAbnormalPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 清除
    clearFilter: function () {
      this.gmtModified = [];
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.getTableList();
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'style/colors.scss';
</style>
